import { render, staticRenderFns } from "./TakenSurveySection.vue?vue&type=template&id=493abbe7&"
import script from "./TakenSurveySection.vue?vue&type=script&lang=ts&"
export * from "./TakenSurveySection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports